// extracted by mini-css-extract-plugin
module.exports = {"tabs":"index_tabs_3BWji"};